import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { robotoRegular, crystal50, crystal500 } from '@habitech/shared';
import { getCurrentStateLabel } from '@domains/nid-price-availability';

interface PriceAvailabilityBannerProps {
  currentState: number;
  isAvailablePrice: boolean;
  inline?: boolean;
}

export const PriceAvailabilityBanner = ({
  currentState,
  isAvailablePrice,
  inline = false,
}: PriceAvailabilityBannerProps) => {
  if (isAvailablePrice) return null;

  return (
    <div
      style={{
        marginTop: inline ? 0 : '8px',
        padding: '6px 10px',
        borderRadius: '4px',
        backgroundColor: crystal50,
        border: `1px solid ${crystal500}`,
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
      }}
    >
      <p
        style={{
          fontFamily: robotoRegular,
          fontSize: '12px',
          color: crystal500,
          margin: 0,
        }}
      >
        Estado: {currentState}
      </p>
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="tooltip-price-availability">
            {getCurrentStateLabel(currentState)}
          </Tooltip>
        }
      >
        <span
          style={{ cursor: 'pointer', fontSize: '12px', lineHeight: 1 }}
          data-testid="price-availability-tooltip-icon"
        >
          ℹ️
        </span>
      </OverlayTrigger>
    </div>
  );
};
